import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerReview } from 'anchor-shared/lib/model/entity/customerReview';
import { CustomerReviewRatingType } from 'anchor-shared/lib/model/enum/customer-review-rating-type';
import { AggregateReview } from 'anchor-shared/lib/model/interface/aggregate-review';

@Component({
  selector: 'app-vessel-reviews-dialog',
  templateUrl: './vessel-reviews-dialog.component.html',
  styleUrls: ['./vessel-reviews-dialog.component.scss'],
})
export class VesselReviewsDialogComponent implements OnInit {
  vesselReviews: CustomerReview[];
  paginatedReviews: CustomerReview[];
  aggregateReviews: AggregateReview[];
  overallRating: number;
  viewableReviewCount: number = 10;
  isMobile: boolean;

  constructor(
    public dialogRef: MatDialogRef<VesselReviewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.vesselReviews = this.data.vesselReviews;
    this.paginatedReviews = this.vesselReviews.slice(
      0,
      this.viewableReviewCount,
    );
    this.aggregateReviews = this.data.aggregateReviews;
    this.isMobile = this.data.isMobile;
  }

  ngOnInit(): void {
    this.overallRating =
      this.aggregateReviews.find(
        (x) => x.ratingType === CustomerReviewRatingType.Overall,
      )?.rateAverage || 5;
  }

  close() {
    this.dialogRef.close();
  }

  loadMoreData() {
    this.viewableReviewCount += 10;
    this.paginatedReviews = this.vesselReviews.slice(
      0,
      this.viewableReviewCount,
    );
  }
}
